/*
 *
 * Assessment actions
 *
 */

import { createAction } from 'redux-actions';
import {
  GET_ASSESSMENT,
  GET_ASSESSMENT_SUCCESS,
  GET_ASSESSMENT_FAIL,
  GET_ANSWERS,
  GET_ANSWERS_SUCCESS,
  GET_ANSWERS_FAIL,
  PUT_ASSESSMENT,
  PUT_ASSESSMENT_RESULT,
  GET_ASSESSMENT_RESULT,
  GET_ASSESSMENT_RESULT_SUCCESS,
  GET_ASSESSMENT_RESULT_FAIL,
  GET_ASSESSMENT_REPORT,
  GET_ASSESSMENT_REPORT_RESULT,
  PROCESSING,
  ANSWERS_PROCESSING,
} from './constants';

export const processing = createAction(PROCESSING);
export const answersProcessing = createAction(ANSWERS_PROCESSING);
export const getAssessment = createAction(GET_ASSESSMENT);
export const getAssessmentSuccess = createAction(GET_ASSESSMENT_SUCCESS);
export const getAssessmentFail = createAction(GET_ASSESSMENT_FAIL);
export const getAnswers = createAction(GET_ANSWERS);
export const getAnswersSuccess = createAction(GET_ANSWERS_SUCCESS);
export const getAnswersFail = createAction(GET_ANSWERS_FAIL);
export const putAssessment = createAction(PUT_ASSESSMENT);
export const putAssessmentResult = createAction(PUT_ASSESSMENT_RESULT);
export const getAssessmentResult = createAction(GET_ASSESSMENT_RESULT);
export const getAssessmentResultSuccess = createAction(
  GET_ASSESSMENT_RESULT_SUCCESS,
);
export const getAssessmentResultFail = createAction(GET_ASSESSMENT_RESULT_FAIL);
export const getAssessmentReport = createAction(GET_ASSESSMENT_REPORT);
export const getAssessmentReportResult = createAction(
  GET_ASSESSMENT_REPORT_RESULT,
);
